import React from 'react';
import axios from 'axios';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { errorMapper } from '@axmit/error-helper';
import { configureJwtInterceptors } from 'common/axios/jwt';
import { envConfig } from 'common/config/env.config';
import { history, store } from 'app/store';
import 'app/assets/sass/index.scss';
import { App } from 'app/App';

// Sentry initialization
Sentry.init({
  dsn: envConfig.SENTRY_DSN || envConfig.REACT_APP_SENTRY_DSN,
  environment: envConfig.NODE_ENV,
  ignoreErrors: ['ResizeObserver loop limit exceeded'],
});

window.checkSentry = (text?: string) => {
  const msg = `Sentry successfully connected. Config: ${JSON.stringify(envConfig)} ${new Date()}. Test string: ${text}`;
  console.log('Go to slack channel and check an error with message: ');
  console.log(msg);
  Sentry.captureException(msg);
};

// Axios initialization
export const axiosConfig = {
  axios,
  refreshTokenEndpoint: '/auth',
};

configureJwtInterceptors(axiosConfig);

axios.defaults.baseURL = `/api`;
axios.interceptors.request.use((config) => ({
  ...config,
  headers: {
    'Source-Service': 'manager',
    'x-client-version': envConfig.RELEASE_VERSION || envConfig.REACT_APP_RELEASE_VERSION || '',
    ...config.headers,
  },
}));
axios.interceptors.response.use(
  (response) => response.data,
  (error) => errorMapper(error)
);
// Render Setup

const MOUNT_NODE = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  MOUNT_NODE
);
